export { default } from './DealsGlobalReport';
